import React from 'react';
import {
  Alert,
  Box,
  Card,
  CardContent,
  Typography
} from '@mui/material';
import { alpha } from '@mui/material/styles';

const ValidationResult = ({ 
  validationResult, 
  compilationErrors, 
  onClose,
  fieldId // ID of the field this validation relates to
}) => {
  if (!validationResult) return null;

  return (
    <Box sx={{ mb: 2 }} role="alert" aria-live="polite">
      <Alert 
        severity={validationResult.is_valid ? 'success' : 'error'}
        onClose={onClose}
        aria-describedby={fieldId ? `${fieldId}-error` : undefined}
      >
        {validationResult.message}
        {validationResult.error_message && (
          <Typography variant="caption" display="block" sx={{ mt: 1 }}>
            {validationResult.error_message}
          </Typography>
        )}
      </Alert>
      
      {/* Detailed Compilation Errors */}
      {!validationResult.is_valid && compilationErrors.length > 0 && (
        <Card sx={{ mt: 2, backgroundColor: theme => alpha(theme.palette.error.main, 0.05) }}>
          <CardContent>
            <Typography variant="subtitle2" color="error" gutterBottom>
              LaTeX Compilation Errors:
            </Typography>
            <Box component="ul" sx={{ pl: 2, mb: 0 }}>
              {compilationErrors.map((error, index) => (
                <Typography 
                  key={index} 
                  component="li" 
                  variant="body2" 
                  sx={{ 
                    fontFamily: 'monospace',
                    fontSize: '0.875rem',
                    mb: 1,
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word'
                  }}
                >
                  {error}
                </Typography>
              ))}
            </Box>
            <Typography variant="caption" color="textSecondary" sx={{ mt: 2, display: 'block' }}>
              These errors indicate specific LaTeX issues. Common problems include:
              • Undefined control sequences (missing packages or commands)
              • Missing $ for math mode
              • Unbalanced braces or brackets
              • Missing image files
            </Typography>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default ValidationResult;